import type { Block } from '@/types/database';
import { getBlockContent } from '@/types/database';
import { blockRegistry } from './registry';

export function BlockRenderer({ block, basePath }: { block: Block; basePath: string }) {
  const entry = blockRegistry[block.block_type];
  if (!entry) return null;
  const { View } = entry;
  return <View content={getBlockContent(block)} basePath={basePath} />;
}
